<template>
  <CollapsibleCard
    :class="$style.container"
    :isExpanded="isExpanded"
    title="Global Policies"
    @expand="toggleExpanded"
  >
    <template v-slot:content>
      <div>
        <ParagraphBody>
          The default action for users when no policies apply during an authentication attempt.
          <Link
            text="Edit in Settings"
            :to="settingsRoute"
          />
        </ParagraphBody>

        <div :class="$style.resource">
          <img
            :class="$style.resourceIcon"
            src="/img/icons/nav/icon-nav-groups.svg"
          >
          <span :class="$style.resourceText">User Portal</span>
          <GlobalPolicyStatusBadge stateName="UserPortalFallbackPolicyModel" />
        </div>

        <div :class="$style.resource">
          <img
            :class="$style.resourceIcon"
            src="/img/icons/nav/icon-nav-sso.svg"
          >
          <span :class="$style.resourceText">SSO Applications</span>
          <GlobalPolicyStatusBadge stateName="SsoApplicationAccessPolicyModel" />
        </div>

        <div
          :class="$style.resource"
        >
          <img
            :class="$style.resourceIcon"
            src="/img/icons/nav/icon-nav-ldap.svg"
          >
          <span :class="$style.resourceText">JumpCloud LDAP</span>
          <GlobalPolicyStatusBadge stateName="LdapAccessPolicyModel" />
        </div>
      </div>
    </template>
  </CollapsibleCard>
</template>

<script>
// Libraries
import { isObject } from 'lodash';

// Components
import { CollapsibleCard, Link, ParagraphBody } from '@jumpcloud/ui-components';
import GlobalPolicyStatusBadge from 'client/Security/GlobalPolicyStatusBadge.vue';

// Utils
import LocalStorageService from 'client/util/LocalStorageService';
import Util from 'client/util/Util';

import { ItemTypeConsts, ItemTypeRoutes, LocalStorageConsts } from 'client/util/Constants';

const { globalFallbackPolicyExpanded } = LocalStorageConsts;

export default {
  name: 'GlobalPolicyCollapsibleSection',

  components: {
    CollapsibleCard,
    Link,
    ParagraphBody,
    GlobalPolicyStatusBadge,
  },

  LocalStorageService,

  data() {
    return {
      isExpanded: true,
    };
  },

  computed: {
    settingsRoute() {
      return ItemTypeRoutes[ItemTypeConsts.authNPoliciesSettings];
    },
  },

  beforeMount() {
    const { getItem } = this.$options.LocalStorageService;
    const previousSetting = Util.tryParseJson(getItem(globalFallbackPolicyExpanded));

    this.isExpanded = isObject(previousSetting)
      ? this.isExpanded
      : previousSetting;
  },

  methods: {
    toggleExpanded() {
      const { setItem } = this.$options.LocalStorageService;
      const newValue = !this.isExpanded;

      this.isExpanded = newValue;
      setItem(globalFallbackPolicyExpanded, newValue);
    },
  },
};
</script>

<style scoped module>
  .container {
    margin: 1.875em;
  }

  .resourceList {
    font-size: var(--jcBody);
    list-style-type: none;
  }

  .resource {
    align-items: center;
    display: flex;
    margin: 0.75em 0 0 1.5em;
  }

  .resourceText {
    min-width: 8em;
  }

  .resourceIcon {
    margin-right: 0.75em;
    width: 1.25em;
  }
</style>
